import { abstractLitigationCaseRequiredFields } from "../AbstractLitigationCase/abstractLitigationCaseRequiredFields";
import * as stagesCase from "../../Stages/StagesCase";
import { EmploymentContract } from "../../../types/Products/EmploymentLaw/EmploymentContract";

export const employmentContractRequiredFields = {
  ...abstractLitigationCaseRequiredFields,
  //this overwrites default STAGE_CHECKED which is indented because
  //automaticallyGenerateExtrajudicialLetter is not used in employmentContract
  //therefore if the base validation is changed in the future, this might have to be changed
  [stagesCase.STAGE_CHECKED]: (abstractLitigationCase: EmploymentContract) => {
    return [];
  },
};
